import React, {useEffect} from 'react';
import {Text} from 'react-aria-components';
import {useParams} from "react-router-dom";
import api from "../../utils/api";


function DatabaseCSV() {
    const [server, setServer] = React.useState(null)
    const {id} = useParams()

    useEffect(() => {
        api.getDatabase(id).then(newServer => {
            setServer(newServer)
        })
    }, []);

    if (server === null || server === undefined) {
        return <Text>Loading...</Text>
    }

    if (server === undefined) {
        return <Text>Database not found</Text>
    }

    const csvData = []
    server.tables.forEach(table => {
        console.log(table)
        table.columns.forEach(column => {
            csvData.push([
                table.name,
                column.columnName,
                column.dataType,
            ])
        })
    })

    const csvHeader = [
        "\"Table Name\"",
        "\"Column Name\"",
        "\"Column Type\"",
    ]

    const csvContent = csvHeader.join(",") + "\n" + csvData.map(e => e.join(",")).join("\n")
    const csvBlob = new Blob([csvContent], {type: 'text/csv'})
    const csvUrl = URL.createObjectURL(csvBlob)
    const csvLink = document.createElement("a")
    csvLink.href = csvUrl
    csvLink.download = `${server.name}.csv`
    csvLink.click()
    URL.revokeObjectURL(csvUrl)
    return (
        <div className="DatabaseCSV">
            <Text>CSV file generated and downloaded</Text>
        </div>
    )
}


export default DatabaseCSV

